import React from "react";

import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import queryString from "query-string";
import Swal from "sweetalert2";

import ReactLoading from "react-loading";
import config from "../../config";

import { useNetworkState } from "react-use";
import Footer from "./Footer";
import Header from "./Header";

const Rate_calculator = () => {
  const [dimensionState, setdimensionState] = React.useState({
    companyDetail: [],
  });

  const [parceltype, setparceltypeState] = React.useState({ parcel: true });
  const [documenttype, setdocumenttypeState] = React.useState({
    document: false,
  });
  const [state, setState] = React.useState({
    parcel_type: "Parcel",
    from_postal_code: "",
    to_postal_code: "",
    mode: "Domestic",
    weight: "",
    length: "",
    width: "",
    height: "",
    country_name: "",
  });
  // console.log("state === " , state)
  const [active, setactive] = React.useState(0);
  const [statepackage, setStatepackage] = React.useState([]);
  const [loadingstate, setLoadingstate] = React.useState({ loading: false });
  const [errorstate, seterrorstate] = React.useState({ message: "" });
  const [paymentmode, setpaymentmode] = React.useState({ mode: 1 });
  const [codvalue, setcodvalue] = React.useState({ cod_amount: 0, err: {} });
  const [volume, setVolume] = React.useState();
  const [countryList, setcountryList] = React.useState([]);
  const [volstate, setVolstate] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }

  React.useEffect(() => {
    getCountryList();
  }, []);

  const handleChange = (e) => {
    console.log("namess", e.target.name);
    console.log("value", e.target.value);
    console.log("type", e.target.type);

    let names = e.target.name;
    let value = e.target.value;

    if (e.target.type == "text") {
      setState({ ...state, [e.target.name]: value });
    } else if (e.target.type == "select-one") {
      setState({ ...state, [e.target.name]: value });
    } else if (e.target.type == "radio") {
      if (e.target.checked == true) {
        if (e.target.name == "document") {
          setparceltypeState({ ...parceltype, parcel: false });
          setdocumenttypeState({ ...documenttype, document: true });
          setState({ ...state, parcel_type: "Document" });
        } else {
          setparceltypeState({ ...parceltype, parcel: true });
          setdocumenttypeState({ ...documenttype, document: false });
          setState({ ...state, parcel_type: "Parcel" });
        }
      }
    } else if (e.target.type == "number") {
      setState({ ...state, [e.target.name]: value });
    } else if (e.target.type == "date") {
      setState({ ...state, [e.target.name]: value });
    }
  };

  const changebar = () => {
    setactive(1);
    setState({
      ...state,
      mode: "International",
      parcel_type: "Parcel",
      from_postal_code: "",
      to_postal_code: "",
      weight: "",
      length: "",
      width: "",
      height: "",
      country_name: "",
    });
    setStatepackage([]);
  };
  const changebar1 = () => {
    setactive(0);
    setState({
      ...state,
      mode: "Domestic",
      parcel_type: "Parcel",
      from_postal_code: "",
      to_postal_code: "",
      weight: "",
      length: "",
      width: "",
      height: "",
      country_name: "",
    });
    setStatepackage([]);
  };

  const get_list = async (sortValue) => {
    setLoadingstate({ ...loadingstate, loading: true });
    if (
      state.from_postal_code != "" &&
      state.to_postal_code != "" &&
      state.mode != "" &&
      state.parcel_type != "" &&
      state.weight != "" &&
      state.height != "" &&
      state.width != "" &&
      state.length != ""
    ) {
      if (
        paymentmode.mode == 1 ||
        (paymentmode.mode == 2 && codvalue.cod_amount != "")
      ) {
        let sort = "default";
        if (sortValue) {
          sort = sortValue;
        }
        let dataToSend = {
          customer_id: userData.customer_id,
          from_postal_code: state.from_postal_code,
          to_postal_code: state.to_postal_code,
          weight:
            volume && state.weight != ""
              ? parseFloat(volume) > parseFloat(state.weight)
                ? volume
                : state.weight
              : 0.0,
          length: state.length,
          height: state.height,
          width: state.width,
          //  sort_by:sort ,
          parcel_type: state.parcel_type,
          mode: state.mode,
          payment_mode: paymentmode.mode == 2 ? "cod" : "prepaid",
          order_amount: codvalue.cod_amount,
          carrier_type: 1,

          from_country_code: "IN",

          to_country_code: "IN",
          moving_type: "Forward",
        };

        // console.log("datatoSend",dataToSend)
        let url = config.apiUrl + "/shipment/shipment_rate_time";

        // // console.log("headers => ", config.headers);

        axios
          .post(url, dataToSend, { headers: config.headers })
          .then((responseJson) => {
            // console.log("responseJson => ", responseJson.data);
            setLoadingstate({ ...loadingstate, loading: false });
            if (responseJson.data.status == "success") {
              setStatepackage(responseJson.data.output);
              if (responseJson.data.output.length == 0) {
                seterrorstate({
                  ...errorstate,
                  message:
                    "No services available for the selected route and package combination.",
                });
              }
            } else {
              const Toast = Swal.mixin({
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire({
                background: "#a61c09",
                type: "Unsuccess",
                title: responseJson.data.message,
                color: "white",
              });
            }
          })
          .catch((error) => {
            //Hide Loader
            setLoadingstate({ ...loadingstate, loading: false });
            // console.log(error);
          });
      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });

        Toast.fire({
          background: "#a61c09",
          type: "unsuccess",
          title: "Please enter cod value",
          color: "white",
        });
        setLoadingstate({ ...loadingstate, loading: false });
      }
    } else {
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });
      Toast.fire({
        background: "#a61c09",
        type: "Unsuccess",
        title: "Please Fill All the Fields",
        color: "white",
      });
      setLoadingstate({ ...loadingstate, loading: false });
    }
  };
  const get_list_international = async (sortValue) => {
    setLoadingstate({ ...loadingstate, loading: true });
    if (
      state.country_name != "" &&
      state.mode != "" &&
      state.parcel_type != "" &&
      state.weight != "" &&
      state.height != "" &&
      state.width != "" &&
      state.length != ""
    ) {
      if (
        paymentmode.mode == 1 ||
        (paymentmode.mode == 2 && codvalue.cod_amount != "")
      ) {
        let sort = "default";
        if (sortValue) {
          sort = sortValue;
        }
        let dataToSend = {
          customer_id: userData.customer_id,

          weight:
            volume && state.weight != ""
              ? parseFloat(volume) > parseFloat(state.weight)
                ? volume
                : state.weight
              : 0.0,
          length: state.length,
          height: state.height,
          width: state.width,
          sort_by: sort,
          parcel_type: state.parcel_type,
          mode: state.mode,
          payment_mode: paymentmode.mode == 2 ? "cod" : "prepaid",
          order_amount: codvalue.cod_amount,
          carrier_type: 1,

          from_country_code: "IN",

          to_country_code: "IN",
          to_country: state.country_name,
        };

        // console.log("datatoSend",dataToSend)
        let url = config.apiUrl + "/shipment/international_shipment_rate_time";

        // // console.log("headers => ", config.headers);

        axios
          .post(url, dataToSend, { headers: config.headers })
          .then((responseJson) => {
            // console.log("responseJson => ", responseJson.data);
            setLoadingstate({ ...loadingstate, loading: false });
            if (responseJson.data.status == "success") {
              setStatepackage(responseJson.data.output);
              if (responseJson.data.output.length == 0) {
                seterrorstate({
                  ...errorstate,
                  message:
                    "No services available for the selected route and package combination.",
                });
              }
            } else {
              const Toast = Swal.mixin({
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire({
                background: "#a61c09",
                type: "Unsuccess",
                title: responseJson.data.message,
                color: "white",
              });
            }
          })
          .catch((error) => {
            //Hide Loader
            setLoadingstate({ ...loadingstate, loading: false });
            // console.log(error);
          });
      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });

        Toast.fire({
          background: "#a61c09",
          type: "unsuccess",
          title: "Please enter cod value",
          color: "white",
        });
        setLoadingstate({ ...loadingstate, loading: false });
      }
    } else {
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });
      Toast.fire({
        background: "#a61c09",
        type: "Unsuccess",
        title: "Please Fill All the Fields",
        color: "white",
      });
      setLoadingstate({ ...loadingstate, loading: false });
    }
  };

  // const sort_by = (e) =>{
  // // console.log(e.target.value);
  // get_list(e.target.value)
  // }
  React.useEffect(() => {
    // if(apiFlag){
    //   apiFlag = false;
    // get_list()
    vol_status_function();
    dimension_detail();
    // }
  }, []);
  const dimension_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setdimensionState({
          ...dimensionState,
          companyDetail: res.data.companyDetail,
        });
        // console.log("rnmmmmm", res);
      })
      .catch((e) => {
        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      });
  };

  const reset = () => {
    setState({
      ...state,
      parcel_type: "Parcel",
      from_postal_code: "",
      to_postal_code: "",
      mode: active == 0 ? "Domestic" : "International",
      weight: "",
      length: "",
      width: "",
      height: "",
      country_name: "",
    });
    setdocumenttypeState({ ...documenttype, document: false });
    setparceltypeState({ ...parceltype, parcel: true });
    setcodvalue({ ...codvalue, cod_amount: 0, err: {} });
  };
  const payment_mode = (e) => {
    if (e.target.name == "prepaid") {
      setpaymentmode({ mode: 1 });
    } else {
      setpaymentmode({ mode: 2 });
    }
  };
  const codvalueChange = (e) => {
    setcodvalue({ ...codvalue, cod_amount: e.target.value, err: {} });
  };
  const vol_status_function = () => {
    let full_api = config.apiUrl + `/user/customer_volumetric_status`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setVolstate(res.data.volumetric_status);
        // console.log("rnmmmmm", res);
      })
      .catch((e) => {
        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      });
  };

  React.useEffect(() => {
    if (state.height !== "" && state.width !== "" && state.length !== "") {
      let divisor = volstate === 1 ? 5000 : 1;
      const calculatedVolume =
        (state.height * state.width * state.length) / divisor;
      setVolume(calculatedVolume.toFixed(2));
    } else {
      setVolume(0);
    }
  }, [state.height, state.width, state.length, volstate]);

  const getCountryList = () => {
    let url = config.apiUrl + "/country/country_list_international";
    let sendData = { limit: 300, status: 1 };
    // console.log("bb", sendData);
    axios
      .post(url, sendData, { headers: config.headers })
      .then((res) => {
        // console.log("res ", res);
        setcountryList(res.data.output);
      })
      .catch((e) => {});
  };

  return (
    <div>
      <Header>
        <div class="content">
          {/* <!-- ═══════════ PAGE HEADER ═══════════ --> */}
          <div class="ol-header">
            <div class="ol-hd">
              <a
                href="javascript:history.back();"
                class="ol-back"
                title="Go back"
              >
                <i class="bi bi-arrow-left"></i>
              </a>
              <div>
                <div class="ol-title">Rate Calculator</div>
                <div class="ol-sub">
                  <span class="dot"></span> Shipping Rates{" "}
                  <span class="dot" style={{ background: "var(--t4)" }}></span>{" "}
                  Tools
                </div>
              </div>
            </div>
            <div class="ol-actions">
              <a href="/rate_card" class="ol-btn">
                <i class="bi bi-receipt"></i> View Rate Card
              </a>
            </div>
          </div>

          {/* <!-- ═══════════ INTRO ═══════════ --> */}
          <div class="ig-hero">
            <span class="ig-eyebrow">
              <i class="bi bi-calculator"></i> Shipping Rates
            </span>
            <h1 class="ig-title">Rate Calculator</h1>
            <p class="ig-desc">
              Estimate domestic shipping charges instantly from the weight,
              dimensions and delivery pincode of your shipment.
            </p>
          </div>

          <div class="rc-wrap">
            <div class="rc-calc-grid">
              {/* <!-- ═══════════ CALCULATOR FORM ═══════════ --> */}
              <div class="card-base ol-co-card">
                <div class="ol-co-head">
                  <i class="bi bi-sliders"></i> Shipment Details
                </div>
                <div class="ol-co-body">
                  <label class="rw-label">Shipment Type</label>
                  <div class="rc-seg" id="rcShipType">
                    <button
                      type="button"
                      class="rc-seg-btn on"
                      data-val="forward"
                    >
                      Forward
                    </button>
                    {/* <button type="button" class="rc-seg-btn" data-val="return">
                      Return
                    </button> */}
                  </div>

                  <div class="ol-co-grid2 rc-mt">
                    <div>
                      <label class="rw-label" for="rcPickupPin">
                        Pickup Pincode
                      </label>
                      <input
                        type="text"
                        class="rc-input"
                        id="rcPickupPin"
                        inputmode="numeric"
                        maxlength="6"
                        placeholder="e.g. 400071"
                        name="from_postal_code"
                        value={state.from_postal_code}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div>
                      <label class="rw-label" for="rcDeliveryPin">
                        Delivery Pincode
                      </label>
                      <input
                        type="text"
                        class="rc-input"
                        id="rcDeliveryPin"
                        inputmode="numeric"
                        maxlength="6"
                        name="to_postal_code"
                        value={state.to_postal_code}
                        onChange={(e) => handleChange(e)}
                        placeholder="e.g. 560001"
                      />
                    </div>
                  </div>

                  <div class="ol-co-grid2 rc-mt">
                    <div>
                      <label class="rw-label" for="rcWeight">
                        Actual Weight
                      </label>
                      <div class="ol-input-affix">
                        <input
                          type="text"
                          id="rcWeight"
                          inputmode="decimal"
                          name="weight"
                          onChange={(e) => handleChange(e)}
                          value={state.weight}
                          placeholder="0.00"
                        />
                        <span>KG</span>
                      </div>
                    </div>
                    <div>
                      <label class="rw-label">
                        Dimensions (H &times; W &times; L)
                      </label>
                      <div class="ol-co-grid3">
                        <div class="ol-input-affix">
                          <input
                            type="text"
                            id="rcH"
                            inputmode="decimal"
                            placeholder="H"
                            onChange={(e) => handleChange(e)}
                            name="height"
                            value={state.height}
                          />
                          <span>cm</span>
                        </div>
                        <div class="ol-input-affix">
                          <input
                            type="text"
                            id="rcW"
                            inputmode="decimal"
                            placeholder="W"
                            onChange={(e) => handleChange(e)}
                            name="width"
                            value={state.width}
                          />
                          <span>cm</span>
                        </div>
                        <div class="ol-input-affix">
                          <input
                            type="text"
                            id="rcL"
                            inputmode="decimal"
                            placeholder="L"
                            onChange={(e) => handleChange(e)}
                            name="length"
                            value={state.length}
                          />
                          <span>cm</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="ol-co-grid2 rc-mt">
                    <div>
                      <label class="rw-label">Payment Type</label>
                      <div className="rc-seg" id="rcPayType">
                        <button
                          type="button"
                          className={`rc-seg-btn ${
                            paymentmode.mode == 2 ? "on" : ""
                          }`}
                          name="cod"
                          onClick={(e) => payment_mode(e)}
                        >
                          COD
                        </button>

                        <button
                          type="button"
                          className={`rc-seg-btn ${
                            paymentmode.mode == 1 ? "on" : ""
                          }`}
                          name="prepaid"
                          onClick={(e) => payment_mode(e)}
                        >
                          Prepaid
                        </button>
                      </div>
                    </div>
                    {/* <div>
                      <label class="rw-label">Dangerous Goods?</label>
                      <div class="rc-seg" id="rcDg">
                        <button type="button" class="rc-seg-btn" data-val="yes">
                          Yes
                        </button>
                        <button
                          type="button"
                          class="rc-seg-btn on"
                          data-val="no"
                        >
                          No
                        </button>
                      </div>
                    </div> */}
                  </div>
                  {paymentmode.mode == 2 ? (
                    <div class="row mt-2">
                      <div class="col-12 col-md-5 mb-3">
                        <label class="rw-label">Enter COD Amount</label>
                        <input
                          type="text"
                          class="form-control"
                          id=""
                          placeholder="Enter COD amount"
                          name="cod_amount"
                          onChange={(e) => codvalueChange(e)}
                          value={codvalue.cod_amount}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* <div class="rc-mt">
                    <label class="rw-label" for="rcValue">
                      Shipment Value
                    </label>
                    <div class="ol-input-affix">
                      <span>&#8377;</span>
                      <input
                        type="text"
                        id="rcValue"
                        inputmode="decimal"
                        placeholder="0.00"
                      />
                    </div>
                  </div> */}
                </div>
                <div class="ol-co-foot">
                  <span>
                    Volumetric weight (H&times;W&times;L / 5000) is billed when
                    higher than actual.
                  </span>
                  <div class="rc-foot-btns">
                    <button
                      type="button"
                      class="ol-btn ghost"
                      id="rcCalcReset"
                      onClick={() => reset()}
                    >
                      <i class="bi bi-arrow-counterclockwise"></i> Reset
                    </button>
                    <button
                      type="button"
                      class="ol-btn primary"
                      id="rcCalcGo"
                      onClick={() => get_list()}
                    >
                      <i class="bi bi-calculator"></i> Calculate
                    </button>
                  </div>
                </div>
              </div>

              {/* <!-- ═══════════ RESULTS ═══════════ --> */}
              <div class="card-base ol-co-card rc-results">
                <div class="ol-co-head">
                  <i class="bi bi-box-seam"></i> Estimated Rates
                  <span class="rc-result-count" id="rcResultCount"></span>
                </div>
                <div class="ol-co-body rc-results-body" id="rcResultsBody">
                  {loadingstate.loading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ReactLoading
                        type={"spin"}
                        color={"#0d6efd"}
                        height={300}
                        width={89}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <h3>{errorstate.message}</h3>
                  {statepackage.length != 0
                    ? statepackage.map((item, index) => (
                        <div class="rc-result-item">
                          <div class="rc-result-top">
                            <span class="rc-badge">
                              {" "}
                              <img
                                src={`https://cdn.shipuncle.in/images/${item.carrierImage}`}
                                class="img-fluid"
                              />
                            </span>
                            <div class="rc-result-tx">
                              <div class="rc-result-name">
                                <h6>{item.service_provider}</h6>
                                <span class="rc-zone-chip">
                                  {item?.zone_name || ""}
                                </span>
                              </div>
                              <div class="rc-result-sub">
                                Domestic &middot;
                                <small>
                                  {volume && state.weight !== ""
                                    ? (parseFloat(volume) >
                                      parseFloat(state.weight)
                                        ? volume
                                        : state.weight) + " Kg"
                                    : "0.00 Kg"}
                                </small>{" "}
                                billable &middot; Forward shipment
                              </div>
                            </div>
                            <div class="rc-result-total">
                              <h5>
                                {dimensionState.companyDetail.map(
                                  (subscriber) => (
                                    <>₹</>
                                  )
                                )}
                                {parseFloat(
                                  Number(item.total_charges) +
                                    Number(item.commission_charge)
                                ).toFixed(2)}
                              </h5>
                            </div>
                          </div>
                        </div>
                      ))
                    : ""}
                  {/* <?php endforeach; ?> */}
                  <div class="rc-sort-dir">
                    Sorted by estimated total, lowest first
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Rate_calculator;
